jQuery(document).ready(function ($) {
  if (window.location.pathname === '/ma-selection/') {
    const elem = $('.search-icon');
    if (elem.length > 0) {
      elem.addClass('active');
    }
  } else if (window.location.pathname === '/mon-panier/') {
    const elem = $('.nav-cart-icon');
    if (elem.length > 0) {
      elem.addClass('active');
    }
  } else if (window.location.pathname.includes('/supports/') || window.location.pathname.includes('/kits/')) {
    const menuItem = $('.elementor-nav-menu li.menu-item-535');
    if (menuItem.length > 0) {
      menuItem.addClass('current-menu-item current_page_item');
      menuItem.find('a').addClass('elementor-item-active').attr('aria-current', 'page');
    }
  }
});
